import { createSelector } from "@reduxjs/toolkit";
import { Directions } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getDirections = createSelector(
  (state: RootState) => state.gop[NameSpace.Directions],
  (state: Directions) => state.data
);

export const getFetchingStatusDirections = createSelector(
  (state: RootState) => state.gop[NameSpace.Directions],
  (state: Directions) => state.fetchingStatusDirections
);
